import Navbar from "../../components/tickets/navBar";
import EventCard from "../../components/tickets/eventCard";
import banner from "../../assets/banner.jpg";
import { useEffect, useState } from "react";
import PageLoader from "../../components/pageLoader";
import { getStoreEvents } from "../../api/ticketsPlatform/events";
import Footer from "../../components/tickets/footer";
import CookieBanner from "../../components/tickets/cookieBanner";
import { useTranslation } from "react-i18next";
export default function Events() {
  const { t } = useTranslation();
  const [events, setEvents] = useState([]);

  const [loading, setLoading] = useState(true);

  const fetchEvents = async () => {
    try {
      setLoading(true);

      const data = await getStoreEvents();

      setEvents(data.results || []);
    } catch (err) {
      // err
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  useEffect(() => {
    window.BrevoConversationsID = "69d6c076b5525827090a16e7";
    window.BrevoConversations =
      window.BrevoConversations ||
      function () {
        (window.BrevoConversations.q = window.BrevoConversations.q || []).push(
          arguments,
        );
      };
    const s = document.createElement("script");
    s.async = true;
    s.src = "https://conversations-widget.brevo.com/brevo-conversations.js";
    document.head.appendChild(s);

    return () => {
      // cleanup if needed
      document.head.removeChild(s);
    };
  }, []);

  if (loading) {
    return <PageLoader />;
  }

  return (
    <div className="bg-[#000d09] text-white min-h-screen">
      <Navbar />

      {/* HERO */}
      <div
        className="relative h-[50vh] md:h-[70vh] min-h-[400px] flex items-end justify-center text-center"
        style={{
          backgroundImage: `url(${banner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* Overlay */}
        <div
          className="absolute inset-0 bg-gradient-to-b 
            from-[#000d09]/10 
            via-[#000d09]/30 
            to-[#000d09]"
        />

        {/* Light boost layer */}
        <div className="absolute inset-0" />

        <div className="relative z-10 pb-10 md:pb-14 px-4">
          <p className="text-green-400 tracking-widest text-xs md:text-sm">
            {t("events.upcoming")}
          </p>
          <h1 className="text-3xl md:text-5xl font-bold mt-2 leading-tight">
            {t("events.available")}
          </h1>
        </div>
      </div>
      {/* EVENT LIST */}
      <div className="max-w-4xl mx-auto px-4 py-10 space-y-6">
        {events.map((event) => (
          <EventCard key={event.id} event={event} />
        ))}
      </div>

      <Footer />
      <CookieBanner />
    </div>
  );
}
